import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-baobiao",
  "use": "icon-baobiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-baobiao\"><defs><style type=\"text/css\"></style></defs><path d=\"M192 512l0 256L64 768 64 512 192 512M192 448 64 448c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64L256 512C256 476.7 227.3 448 192 448L192 448z\" p-id=\"17521\" /><path d=\"M576 64l0 704L448 768 448 64 576 64M576 0 448 0c-35.3 0-64 28.7-64 64l0 704c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64L640 64C640 28.7 611.3 0 576 0L576 0z\" p-id=\"17522\" /><path d=\"M960 256 960 256C960 256 960 256 960 256l0 512c0 0 0 0 0 0L832 768c0 0 0 0 0 0L832 256c0 0 0 0 0 0L960 256M960 192 832 192c-35.3 0-64 28.7-64 64l0 512c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64L1024 256C1024 220.7 995.3 192 960 192L960 192z\" p-id=\"17523\" /><path d=\"M992 960 32 960c-17.7 0-32-14.3-32-32s14.3-32 32-32l960 0c17.7 0 32 14.3 32 32S1009.7 960 992 960z\" p-id=\"17524\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/baobiao.svg
// module id = aJfs
// module chunks = 65